import React from "react";

const TableWidgetAdminActivity = ({ activities }) => {
    return (
        <div className="col-xxl-6">
            <div className="card card-flush h-md-100">
                <div className="card-header pt-7">
                    <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bold text-gray-800">
                            Recent User Activity
                        </span>
                        <span className="text-gray-500 mt-1 fw-semibold fs-6">
                            Latest system actions
                        </span>
                    </h3>
                </div>
                {/* Body */}
                <div className="card-body pt-4 px-0">
                    <div
                        className="hover-scroll-overlay-y px-9 pe-7 me-3 mb-2"
                        style={{ height: 530 }}
                    >
                        {/* Timeline */}
                        <div className="timeline timeline-border-dashed">
                            {activities?.map((activity, index) => (
                                <div className="timeline-item pb-5" key={index}>
                                    <div className="timeline-line" />
                                    <div className="timeline-icon">
                                        <i
                                            className={`ki-duotone ${activity.icon} fs-2 text-${activity.color}`}
                                        >
                                            <span className="path1" />
                                            <span className="path2" />
                                        </i>
                                    </div>

                                    <div className="timeline-content m-0">
                                        <span
                                            className={`fs-8 fw-bolder text-${activity.color} text-uppercase`}
                                        >
                                            {activity.actionType}
                                        </span>
                                        <div className="fs-6 text-gray-800 fw-bold d-block mt-1">
                                            {activity.description}
                                        </div>
                                        <span className="fw-semibold text-gray-500">
                                            {activity.timestamp}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {/* End Timeline */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TableWidgetAdminActivity;
